import React from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import ImageSearchTwoToneIcon from '@mui/icons-material/ImageSearchTwoTone';
import "./notfound.scss"

const NotFound = () => {

    return (
        <div className="notfound">
            <Helmet>
                <title>404 - Seite nicht gefunden</title>
            </Helmet>
            <div className="container">
                <div className="left">
                    <div className="box">
                        <h5>ERROR 404</h5>
                    </div>
                    <h2>Ups! Seite nicht gefunden.</h2>
                    <p>Leider ist die gewünschte Seite nicht verfügbar.</p>
                    <Link to="/">
                        <button>Zur Startseite</button>
                    </Link>
                </div>
                <div className="symbol">
                    <div className="circle">
                        <ImageSearchTwoToneIcon />
                    </div>
                </div>
            </div>
        </div>
    )
};

export default NotFound